import { RouterOutputs, trpc } from "../trpc";

export type Entitlements = RouterOutputs["account"]["entitlements"];

export function useEntitlements() {
  const {
    data: entitlements,
    isLoading,
    isError,
    error,
  } = trpc.account.entitlements.useQuery();

  return {
    entitlements,
    isLoading,
    isError,
    error,
  };
}
